import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import css from "./side_panel.modules.scss";

const SidePanel = ({ children, show, secondPanel }) => (
  <div className={classNames(css.root, { [css.show]: show, [css.secondPanel]: secondPanel })}>{children}</div>
);

SidePanel.propTypes = {
  children: PropTypes.node,
  show: PropTypes.bool,
  secondPanel: PropTypes.bool
};

SidePanel.defaultProps = {
  secondPanel: false
};

export default SidePanel;
